export default "__VITE_ASSET__DoY7f4jU__"